import { always, anyPass, equals, ifElse, isEmpty, isNil, pipe } from 'ramda';

export const parseNumberUnless = (comperator: (value: any) => boolean) => ifElse(comperator, always(undefined), Number);

const isRangeSafeInteger = (value: number) => anyPass([isNil, isEmpty, pipe(Number, equals(value))]);

/**
 * Returns true if the value is either undefined, null, empty or the Number.MIN_SAFE_INTEGER
 */
export const isRangeMinSafeInteger = isRangeSafeInteger(Number.MIN_SAFE_INTEGER);
/**
 * Returns true if the value is either undefined, null, empty or the Number.MAX_SAFE_INTEGER
 */
export const isRangeMaxSafeInteger = isRangeSafeInteger(Number.MAX_SAFE_INTEGER);

const isEmptyString = equals('');
export const toNumberUnlessEmpty = parseNumberUnless(isEmptyString);
